import { fontSize, theme } from "@tm/utility/global";
import styled from "styled-components";

export const DropdownContainer = styled.div`
  position: relative;
  top: -70px;
  width: 100%;
`;

export const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 490px;
  overflow-y: auto;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
`;

export const StickySearchContainer = styled.div`
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  box-shadow: 0px 2px 3px 0px #0000001a;
`;

export const StickyButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 10;
  box-shadow: 0px 1px 6px 0px #00000033;
  display: flex;
  flex-direction: row-reverse;
  padding: 8px 16px;

  button {
    border-radius: 38px;
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  padding: 0 16px;
`;

export const InputWrapper = styled.div`
  font-size: ${fontSize.font14};
  display: flex;
  align-items: center;
  background: ${theme.whiteText};
  padding: 0 12px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  height: 44px;
`;

export const InputIcon = styled.span`
  font-size: ${fontSize.font20};
  color: ${theme.greyText2};
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

export const CountryInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-size: ${fontSize.font16};
  flex: 1;
  color: ${theme.blackText2};
  height: 40px;
`;
